// extracted by mini-css-extract-plugin
module.exports = {"root":"C_bJ"};